import React from 'react';
import './FakePasswordField.scss';

/**
 * Component to avoid autocompleting fields (because autocomplete will fill in the password which can be shown)
 */
export var FakePasswordField = function FakePasswordField() {
  return /*#__PURE__*/React.createElement("input", {
    id: "pwd",
    className: "FakePasswordField",
    tabIndex: "-1",
    "aria-hidden": "true"
    // Screen readers *should* ignore this field, but some accessibility
    // tools pick it up, so we add an explicit label to be safe
    ,
    "aria-label": "Unused (hidden)",
    type: "password",
    name: "fakepasswordremembered"
  });
};